import { render } from "./PageInputAduan.vue?vue&type=template&id=2d383fd4&scoped=true"
import script from "./PageInputAduan.vue?vue&type=script&lang=js"
export * from "./PageInputAduan.vue?vue&type=script&lang=js"

import "./PageInputAduan.vue?vue&type=style&index=0&id=2d383fd4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d383fd4"]])

export default __exports__